// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jSBxG3P8NhgLGs4K2vIh{align-items:center;gap:8px;display:flex}.jSBxG3P8NhgLGs4K2vIh .uulveg9ikoUN_ELn_M4t{width:64px;height:64px;box-shadow:0 0 0 1px var(--black-20);background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:100%;justify-content:center;align-items:center;display:flex}.jSBxG3P8NhgLGs4K2vIh .uulveg9ikoUN_ELn_M4t.WYTr2zLVPYM3rWPEXBFK{border-radius:6px}.jSBxG3P8NhgLGs4K2vIh .Oag2rNM4SyQkGHVGkTtd{max-width:300px;min-height:16px;margin-top:4px;display:block}.Bb6deLhyFv0TrfpC0Mne{flex-direction:column;padding:0 0 2px 4px;display:flex}.kegDn90dH54ddMr1zYaN{height:-webkit-max-content;height:max-content}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoWrap": `jSBxG3P8NhgLGs4K2vIh`,
	"logo": `uulveg9ikoUN_ELn_M4t`,
	"square": `WYTr2zLVPYM3rWPEXBFK`,
	"logoSubtitle": `Oag2rNM4SyQkGHVGkTtd`,
	"labelWrap": `Bb6deLhyFv0TrfpC0Mne`,
	"uploadButton": `kegDn90dH54ddMr1zYaN`
};
export default ___CSS_LOADER_EXPORT___;
